var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadok16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    width: 16,
    height: 16,
    fill: "none",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88 1a7 7 0 0 0-7 7 7 7 0 0 0 7 7 7 7 0 0 0 1.4219-0.16406l-0.42188-0.42188v-2.4141h2.4141l0.76172 0.76172 1.9668-3.2754 0.29102-0.48633h0.49609a7 7 0 0 0 0.070312-1 7 7 0 0 0-7-7z",
    fill: "#3771c8",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87 4h2v4h2l-3 3-3-3h2z",
    fill: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    style: {
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85 12v1h4v-1z",
    fill: "#fff",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95 10-2.625 4.375-1.375-1.375h-1v1l2 2h1l3-5v-1z",
    color: "#000000",
    fill: "#008000",
    strokeLinecap: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadok16);
export default __webpack_public_path__ + "static/media/download.ok.16.8ac458ff7b5bfd4d2deafaf593ac8432.svg";
export { ForwardRef as ReactComponent };